<template>
  <div>
    <vx-card class="mb-base" style="margin-top: -20px">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-3">
            <v-select
              class="w-full m-2"
              :placeholder="$t('selectCategory')"
              label="categoryName"
              :closeOnSelect="true"
              v-model="selectedCategories"
              :options="categories"
              :reduce="(selectedCategories) => selectedCategories.id"
            />
          </div>
          <div class="col-md-3">
            <vs-input
              class="w-full m-2"
              icon-pack="feather"
              icon="icon-search"
              v-model="searchInput"
              @keypress.enter="searchImages"
            />
          </div>
          <div class="col-md-3">
            <vs-button class="m-2" @click="searchImages">{{
              $t("search")
            }}</vs-button>
          </div>
          <!-- <div class="col">
            <vs-button class="m-2" @click="getProduct(1)">{{$t('bringAll')}}</vs-button>
          </div>-->
        </div>
      </div>
    </vx-card>

    <vx-card class="mb-base" style="margin-top: -20px">
      <vs-tabs alignment="fixed">
        <vs-tab label="IFrame">
          <vs-textarea v-model="ifrm" height="auto" :disabled="both" />
          <div></div>
        </vs-tab>
        <vs-tab label="Url">
          <div class="row">
            <div class="col-md-12">
              <vs-textarea v-model="link" height="90px" />
            </div>
          </div>
        </vs-tab>
        <vs-tab :label="$t('socialMedia')">
          <div class="container-fluid">
            <div class="row">
              <div
                class="
                  col-12
                  d-flex
                  justify-content-center
                  align-items-center
                  text-center
                  overflow-auto
                "
              >
                <div
                  class="mr-4 p-3 cursor-pointer"
                  title="Facebook"
                  @click="facebook"
                >
                  <i
                    class="fab fa-facebook-square fa-3x"
                    style="color: #3b5998"
                  ></i>
                </div>
                <div
                  class="mr-4 p-3 cursor-pointer"
                  title="Twitter"
                  @click="twitter"
                >
                  <i
                    class="fab fa-twitter-square fa-3x"
                    style="color: #1da1f2"
                  ></i>
                </div>
                <div
                  class="mr-4 p-3 cursor-pointer"
                  title="Vkontakte"
                  @click="vk"
                >
                  <i class="fab fa-vk fa-3x" style="color: #45668e"></i>
                </div>
                <div
                  class="mr-4 p-3 cursor-pointer"
                  title="Odnoklassniki"
                  @click="okru"
                >
                  <i
                    class="fab fa-odnoklassniki-square fa-3x"
                    style="color=#ed812b;"
                  ></i>
                </div>
                <div
                  class="mr-4 p-3 cursor-pointer"
                  title="LinkedIn"
                  @click="linkedin"
                >
                  <i class="fab fa-linkedin fa-3x" style="color: #00a0dc"></i>
                </div>
                <div
                  class="mr-4 p-3 cursor-pointer"
                  title="Pinterest"
                  @click="pinterest"
                >
                  <i
                    class="fab fa-pinterest-square fa-3x"
                    style="color: #bd081c"
                  ></i>
                </div>
                <div
                  class="mr-4 p-3 cursor-pointer"
                  title="Flickr"
                  @click="flickr"
                >
                  <i class="fab fa-flickr fa-3x" style="color: #ff0084"></i>
                </div>
                <div
                  class="mr-4 p-3 cursor-pointer"
                  title="Flipboard"
                  @click="flipboard"
                >
                  <i class="fab fa-flipboard fa-3x" style="color: #e12828"></i>
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </vs-tab>
        <vs-tab label="Mail">
          <div class="row">
            <div
              class="
                col-md-12
                d-flex
                justify-content-center
                align-items-center
                text-center
              "
            >
              <vs-button color="primary" type="border" icon="mail">
                <a :href="hrLink">{{ $t("sendMail") }}</a>
              </vs-button>
              <a
                href="https://www.pinterest.com/pin/create/button/"
                data-pin-do="buttonBookmark"
              ></a>
            </div>
          </div>
        </vs-tab>
        <vs-tab :label="$t('messagePlatform')">
          <div class="container-fluid">
            <div class="row">
              <div
                class="
                  col-12
                  d-flex
                  justify-content-center
                  align-items-center
                  text-center
                  overflow-auto
                "
              >
                <div
                  class="mr-4 p-3 cursor-pointer"
                  title="Whatsapp"
                  @click="whatsapp"
                >
                  <i
                    class="fab fa-whatsapp-square fa-3x"
                    style="color: #25d366"
                  ></i>
                </div>
                <div
                  class="mr-4 p-3 cursor-pointer"
                  title="Telegram"
                  @click="telegram"
                >
                  <i class="fab fa-telegram fa-3x" style="color: #0088cc"></i>
                </div>
                <div
                  class="mr-4 p-3 cursor-pointer"
                  title="Skype"
                  @click="skype"
                >
                  <i class="fab fa-skype fa-3x" style="color: #00aff0"></i>
                </div>
                <!-- <div class="mr-4 p-3 cursor-pointer" title="Viber" @click="viber">
                  <i class="fab fa-viber fa-3x" style="color:#8f5db7;"></i>
                </div>-->
              </div>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>

    <div class="vx-row">
      <div
        class="vx-col w-full relative data-list-container"
        id="data-list-thumb-view"
      >
        <vs-table
          multiple
          v-model="selectedProduct"
          ref="table"
          :max-items="20"
          :data="products"
        >
          <template slot="thead">
            <vs-th>{{ $t("photos") }}</vs-th>
            <vs-th sort-key="name">{{ $t("productName") }}</vs-th>
            <vs-th sort-key="productCode">{{ $t("productCode") }}</vs-th>
            <vs-th sort-key="createDate">{{ $t("addedDate") }}</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="img-container">
                  <img
                    v-if="tr.productFiles.length > 0"
                    :src="
                      'https://api.360photoboxcloud.com/' +
                      tr.productFiles[0].fileName
                    "
                    :alt="tr.name"
                    style="height: 100px"
                  />
                  <img
                    v-else
                    src="../../../assets/images/nophoto.jpg"
                    alt
                    style="height: 100px"
                  />
                </vs-td>

                <vs-td>
                  <p class="product-name font-medium truncate">{{ tr.name }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.productCode }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-price">{{ tr.createDate }}</p>
                </vs-td>
                <vs-td></vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </div>
    <vs-popup
      class="holamundo"
      v-if="popupActivo == true"
      :active.sync="popupActivo"
    >
      <div class="row">
        <div class="col-md-6">
          <img height="300vh" width="300vw" :src="selectedImage" />
        </div>
        <div class="col-md-6">
          <ul class="list-group">
            <li class="list-group-item">
              {{ $t("productName") }} : {{ details.name }}
            </li>
            <li class="list-group-item">
              {{ $t("productCode") }} : {{ details.productCode }}
            </li>
            <li class="list-group-item">
              {{ $t("barcode") }} : {{ details.productBarcode }}
            </li>
            <li class="list-group-item">
              {{ $t("frameCount") }} : {{ details.frameCount }}
            </li>
            <li class="list-group-item">
              {{ $t("categoryName") }} : {{ details.categoryName }}
            </li>
          </ul>
        </div>
      </div>
    </vs-popup>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <vs-pagination
            class="m-2"
            v-show="products.length != 0"
            :total="totalPage"
            :max="6"
            v-model="page"
            @change="getProduct"
          ></vs-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";
import VideoTab from "./ShareComponents/VideoTab";

export default {
  components: {
    "video-tab": VideoTab,
  },
  computed: {
    both() {
      if (this.selectedProduct.length > 1 || this.selectedProduct.length != 0)
        return false;
      return true;
    },
    only() {
      if (this.selectedProduct.length == 1) {
        this.active = true;
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      colorx: "#7267f0",
      details: {},
      selectedImage: "",
      popupActivo: false,
      active: false,
      products: [],
      categories: [],
      productDetails: [],
      page: 1,
      totalPage: 0,
      selectedCategories: "",
      selectedProduct: [],
      checkboxAll: false,
      searchInput: "",
      link: "",
      ifrm: "",
      popupActivo: false,
      hrLink: "",
      name: "",
      twitUrl: "",
      vkLink: "",
    };
  },
  updated() {
    if (this.selectedProduct.length == 1) {
      this.ifrm = `<iframe src="https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}" width="auto" height="auto" frameborder="0" scrolling="no" style="background-color: #fff; border: 0;" allowfullscreen></iframe>`;
      this.link = `https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}`;
      var a = "mailto:?subject=&body=";
      this.selectedProduct.forEach((item) => {
        a += `${item.name}: https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${item.clientViewCode} `;
      });
      this.hrLink = a;
    } else if (this.selectedProduct.length > 1) {
      var arr = "";
      this.selectedProduct.forEach((item) => {
        arr += `https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${item.clientViewCode} , `;
      });
      this.link = arr;
    }
    if (this.selectedProduct.length == 0) {
      this.ifrm = ``;
      this.link = "";
    }
  },
  methods: {
    showDetail(data) {
      this.details = {
        name: data.name,
        categoryName: data.categoryName,
        productCode: data.productCode,
        productBarcode: data.productBarcode,
        frameCount: data.frameCount,
      };
      this.selectedImage =
        "https://api.360photoboxcloud.com/" + data.productFiles[0].fileName;
      this.popupActivo = true;
    },
    whatsapp() {
      let links = "https://api.whatsapp.com/send?text=";
      this.selectedProduct.forEach((item) => {
        links += `${item.name}: https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${item.clientViewCode} `;
      });
      window.open(links);
    },
    telegram() {
      var result = `https://t.me/share/url?url=https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}&text=${this.selectedProduct[0].name}`;
      window.open(result);
    },
    viber() {
      var result = `viber://forward?text=https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}`;
      window.open(result);
    },
    skype() {
      var result = `https://web.skype.com/share?url=https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}&text=${this.selectedProduct[0].name}`;
      window.open(result);
    },
    facebook() {
      var result = `https://www.facebook.com/sharer/sharer.php?u=https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}`;
      window.open(result);
    },
    youtube() {},
    linkedin() {
      var result = `https://www.linkedin.com/sharing/share-offsite/?url=https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}`;
      window.open(result);
    },
    instagram() {},
    tumblr() {},
    flipboard() {},
    flickr() {},
    okru() {
      var result = `https://connect.ok.ru/offer?url=https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}&title=${this.selectedProduct[0].name}`;
      window.open(result);
    },
    pinterest() {
      var result = `http://pinterest.com/pin/create/link/?url=https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}`;
      window.open(result);
    },
    vk() {
      var result = `http://vk.com/share.php?url=https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}`;
      window.open(result);
    },
    twitter() {
      var result = `https://twitter.com/intent/tweet?text=https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}`;
      window.open(result);
    },
    iframe() {},
    url() {
      this.url = `https://panel.360photoboxcloud.com/viewer360/viewer.html?id=${this.selectedProduct[0].clientViewCode}`;
    },

    validationsUser() {
      if (this.$store.state.role == "Admin") {
        let obj;
        if (this.selectedCategories != "" && this.searchInput != "") {
          obj = {
            RequestPage: 1,
            SearchText: this.searchInput,
            categoryid: this.selectedCategories,
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        } else if (this.selectedCategories != "" && this.searchInput == "") {
          obj = {
            RequestPage: 1,
            categoryid: this.selectedCategories,
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        } else {
          obj = {
            RequestPage: 1,
            SearchText: this.searchInput,
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        }
        let path = "/products/getlist";
        return [obj, path];
      }
      if (this.$store.state.role == "User") {
        let obj;
        if (this.selectedCategories != "" && this.searchInput != "") {
          obj = {
            RequestPage: parseInt(this.page),
            SearchText: this.searchInput,
            categoryid: this.selectedCategories,
            CustomerUserId: parseInt(this.$store.state.userId),
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        } else if (this.selectedCategories != "" && this.searchInput == "") {
          obj = {
            RequestPage: parseInt(this.page),
            categoryid: this.selectedCategories,
            CustomerUserId: parseInt(this.$store.state.userId),
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        } else {
          obj = {
            RequestPage: parseInt(this.page),
            SearchText: this.searchInput,
            CustomerUserId: parseInt(this.$store.state.userId),
            WithVideoFile: false,
            WithAllFilesList: false,
            WithPropertiesList: false,
            WithSettings: false,
          };
        }
        let path = "/products/getbycustomeruserid";
        return [obj, path];
      }
    },
    async searchImages() {
      if (this.selectedCategories == null) this.selectedCategories = "";
      /* if (this.searchInput == "" && this.selectedCategories == "")
        return notify.warning(this.$t("fillAll"));*/

      let data = await this.validationsUser();

      let path = data[1];
      http.post(path, data[0]).then((response) => {
        if (response.data.length == 0) {
          return notify.warning(this.$t("noMatch"));
        } else {
          this.products = response.data;
          this.totalPage = response.totalPage;
          this.page = response.currentPage;
        }
      });
    },
    async getProduct(page) {
      /*  this.products = [];
      let data = await this.validationsUser();

      let path = data[1];
      http.post(path, data[0]).then((response) => {
        if (response.data.length == 0) {
          return notify.warning(this.$t("noMatch"));
        } else {
          this.products = response.data;
          this.totalPage = response.totalPage;
          this.page = response.currentPage;
        }
      });*/
      //  if (page == "") page = 1;
      //  this.products = [];
      let data = await this.validationsUser();
      let path = data[1];
      data[0].RequestPage = page;
      http.post(path, data[0]).then((response) => {
        this.products = response.data;
        this.totalPage = response.totalPage;
        this.page = response.currentPage;
      });
    },
    //Get Categories
    getCategories() {
      let path = "/categories/GetList";
      http.get(path).then((response) => {
        response.forEach((element) => {
          this.categories.push({
            id: element.id,
            categoryName: element.categoryName,
          });
        });
      });
    },

    sendMail() {
      this.hrLink = `mailto:''?subject=${this.name}&body=${this.link}`;
    },
  },
  created() {
    // this.getProduct();
    this.getCategories();
  },
};
</script>
<style scoped>
.asd {
  justify-content: s;
}
/* .kenar {
  border-radius: 15px;
}
.kenar:hover {
  background-color: rgb(221, 221, 221);
} */
</style>
<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }
    .ml-0 {
      margin-left: 0px !important ;
    }
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }
    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
